/* Prophecy Trust — reveal, rolling numbers, review marquee */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reels(el) {
    el.querySelectorAll('[data-pt-roll]').forEach((n, k) => {
      if (n.dataset.ptBuilt) return; n.dataset.ptBuilt = '1';
      const txt = n.getAttribute('data-pt-roll');
      n.setAttribute('aria-label', n.getAttribute('aria-label') || txt);
      const frag = document.createDocumentFragment();
      [...txt].forEach((ch, i) => {
        if (!/[0-9]/.test(ch)) { const s = document.createElement('span'); s.textContent = ch; s.setAttribute('aria-hidden', 'true'); frag.appendChild(s); return; }
        const reel = document.createElement('span'); reel.className = 'pt-reel'; reel.setAttribute('aria-hidden', 'true');
        const strip = document.createElement('span');
        const d = +ch, spins = 1; // one full spin then land
        for (let r = 0; r <= spins; r++) for (let v = 0; v <= 9; v++) { if (r === spins && v > d) break; const c = document.createElement('span'); c.textContent = v; strip.appendChild(c); }
        strip.dataset.steps = String(spins * 10 + d);
        strip.style.setProperty('--d', (k * 0.12 + i * 0.08) + 's');
        reel.appendChild(strip); frag.appendChild(reel);
      });
      const small = n.querySelector('small');
      n.textContent = ''; n.appendChild(frag); if (small) n.appendChild(small);
    });
  }
  function roll(el) { el.querySelectorAll('.pt-reel > span').forEach((s) => { s.style.transform = `translateY(-${s.dataset.steps}em)`; }); }

  function init(el) {
    if (el.dataset.ptReady) return; el.dataset.ptReady = '1';
    // marquee: duplicate lane content for a seamless loop
    el.querySelectorAll('.pt-lane').forEach((lane) => {
      const kids = [...lane.children];
      kids.forEach((c) => { const cl = c.cloneNode(true); cl.setAttribute('aria-hidden', 'true'); cl.querySelectorAll('a').forEach((a) => a.tabIndex = -1); lane.appendChild(cl); });
      lane.style.setProperty('--pt-dur', Math.max(30, kids.length * 9) + 's');
    });
    const pause = el.querySelector('.pt-pause');
    if (pause) pause.addEventListener('click', () => {
      const on = el.classList.toggle('is-paused');
      pause.setAttribute('aria-pressed', on);
      pause.querySelector('span').textContent = on ? pause.dataset.play : pause.dataset.pause;
    });
    if (reduce) { el.classList.add('is-in'); return; }
    el.classList.add('pt-js');
    reels(el);
    if (!('IntersectionObserver' in window)) { el.classList.add('is-in'); roll(el); return; }
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { el.classList.add('is-in'); requestAnimationFrame(() => roll(el)); io.disconnect(); } }), { threshold: 0.18 });
    io.observe(el);
  }
  const boot = () => document.querySelectorAll('[data-prophecy-trust]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => { const el = e.target.querySelector('[data-prophecy-trust]'); if (el) { init(el); el.classList.add('is-in'); roll(el); } });
})();
